import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "py-2"
};
const _hoisted_2 = {
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_3 = {
  key: 0,
  class: "notes-wrapper"
};
import { ref, watch } from 'vue';
import LlSwitch from '@/components/LlSwitch.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlTextarea from '@/components/LlTextarea.vue';
export default {
  __name: 'InternalNotesToggle',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const internalShowNotes = ref(false);
    watch(() => props.modelValue, newValue => {
      internalShowNotes.value = !!newValue;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlSwitch, {
        modelValue: internalShowNotes.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => internalShowNotes.value = $event),
        label: "Internal Notes (not visible to clients)",
        disabled: __props.disabled
      }, null, 8, ["modelValue", "disabled"]), _createVNode(LlTooltip, {
        text: "For internal tracking only. Not shared with clients.",
        location: "top"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          icon: "mdi-help-circle",
          class: "ll-info",
          size: "small",
          color: "blue-light-4"
        })]),
        _: 1
      })]), internalShowNotes.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(LlTextarea, {
        "model-value": __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.$emit('update:modelValue', $event)),
        variant: "outlined",
        "hide-details": "true",
        disabled: __props.disabled,
        "no-resize": true,
        placeholder: "Enter notes for internal tracking only.",
        "data-cy": "internal-notes"
      }, null, 8, ["model-value", "disabled"])])) : _createCommentVNode("", true)]);
    };
  }
};